/** Privacy status */
export var PrivacyStatus;
(function (PrivacyStatus) {
    PrivacyStatus["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    PrivacyStatus["PUBLIC"] = "PUBLIC";
    PrivacyStatus["PRIVATE"] = "PRIVATE";
})(PrivacyStatus || (PrivacyStatus = {}));
export var Type;
(function (Type) {
    Type["UNKNOWN_TYPE"] = "UNKNOWN_TYPE";
    Type["FREE"] = "FREE";
    Type["JOIN_REQUEST"] = "JOIN_REQUEST";
    Type["PRICING_PLAN"] = "PRICING_PLAN";
    Type["EVENT"] = "EVENT";
    Type["INVITE_LINK"] = "INVITE_LINK";
    Type["PERSONAL_INVITE"] = "PERSONAL_INVITE";
    Type["ADDED_BY"] = "ADDED_BY";
    Type["ADDED_BY_TPA"] = "ADDED_BY_TPA";
})(Type || (Type = {}));
/**
 * TODO: wrap into a message
 * Group role of a member in a group
 */
export var GroupRole;
(function (GroupRole) {
    /** Unknown role. */
    GroupRole["UNKNOWN_ROLE"] = "UNKNOWN_ROLE";
    /** Regular group member. */
    GroupRole["MEMBER"] = "MEMBER";
    /** Group administrator. */
    GroupRole["ADMIN"] = "ADMIN";
})(GroupRole || (GroupRole = {}));
/** Group Member Status */
export var Status;
(function (Status) {
    /** Unknown status. */
    Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
    /** Group Member has joined the group. */
    Status["JOINED"] = "JOINED";
    /** Group Member has requested to join the group. */
    Status["REQUEST_PENDING"] = "REQUEST_PENDING";
    /** Group Member request to join the group was rejected. */
    Status["REQUEST_REJECTED"] = "REQUEST_REJECTED";
    /** Group Member request to join the group was withdrawn. */
    Status["REQUEST_WITHDRAWN"] = "REQUEST_WITHDRAWN";
})(Status || (Status = {}));
export var ViolationType;
(function (ViolationType) {
    /** Unknown violation. */
    ViolationType["UNKNOWN_VIOLATION"] = "UNKNOWN_VIOLATION";
    ViolationType["NONE"] = "NONE";
    ViolationType["NOT_LOGGED_IN"] = "NOT_LOGGED_IN";
    ViolationType["ALREADY_JOINED"] = "ALREADY_JOINED";
    ViolationType["EVENTS"] = "EVENTS";
    ViolationType["PRICING_PLANS"] = "PRICING_PLANS";
    ViolationType["QUESTIONS"] = "QUESTIONS";
    ViolationType["ADMIN_APPROVAL"] = "ADMIN_APPROVAL";
    ViolationType["SECRET_GROUP"] = "SECRET_GROUP";
})(ViolationType || (ViolationType = {}));
export var Mode;
(function (Mode) {
    Mode["UNKNOWN_MODE"] = "UNKNOWN_MODE";
    Mode["ADD"] = "ADD";
    Mode["INVITE"] = "INVITE";
    Mode["IGNORE"] = "IGNORE";
})(Mode || (Mode = {}));
export var SortOrder;
(function (SortOrder) {
    SortOrder["ASC"] = "ASC";
    SortOrder["DESC"] = "DESC";
})(SortOrder || (SortOrder = {}));
export var SortType;
(function (SortType) {
    /** Number of matches in the results. */
    SortType["COUNT"] = "COUNT";
    /** Alphabetically by the field value. */
    SortType["VALUE"] = "VALUE";
})(SortType || (SortType = {}));
export var SortDirection;
(function (SortDirection) {
    /** Descending order. */
    SortDirection["DESC"] = "DESC";
    /** Ascending order. */
    SortDirection["ASC"] = "ASC";
})(SortDirection || (SortDirection = {}));
export var MissingValues;
(function (MissingValues) {
    /** Exclude missing values from the aggregation results. */
    MissingValues["EXCLUDE"] = "EXCLUDE";
    /** Include missing values in the aggregation results. */
    MissingValues["INCLUDE"] = "INCLUDE";
})(MissingValues || (MissingValues = {}));
export var ScalarType;
(function (ScalarType) {
    ScalarType["UNKNOWN_SCALAR_TYPE"] = "UNKNOWN_SCALAR_TYPE";
    /** Total number of distinct values. */
    ScalarType["COUNT_DISTINCT"] = "COUNT_DISTINCT";
    /** Minimum value. */
    ScalarType["MIN"] = "MIN";
    /** Maximum value. */
    ScalarType["MAX"] = "MAX";
    /** Sum of values. */
    ScalarType["SUM"] = "SUM";
    /** Average of values. */
    ScalarType["AVG"] = "AVG";
})(ScalarType || (ScalarType = {}));
export var NestedAggregationType;
(function (NestedAggregationType) {
    NestedAggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** Calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. */
    NestedAggregationType["VALUE"] = "VALUE";
    /** Calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. */
    NestedAggregationType["RANGE"] = "RANGE";
    /** Calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
    NestedAggregationType["SCALAR"] = "SCALAR";
    /** Calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.). */
    NestedAggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
})(NestedAggregationType || (NestedAggregationType = {}));
export var Interval;
(function (Interval) {
    Interval["UNKNOWN_INTERVAL"] = "UNKNOWN_INTERVAL";
    Interval["YEAR"] = "YEAR";
    Interval["MONTH"] = "MONTH";
    Interval["WEEK"] = "WEEK";
    Interval["DAY"] = "DAY";
    Interval["HOUR"] = "HOUR";
    Interval["MINUTE"] = "MINUTE";
    Interval["SECOND"] = "SECOND";
})(Interval || (Interval = {}));
export var AggregationType;
(function (AggregationType) {
    AggregationType["UNKNOWN_AGGREGATION_TYPE"] = "UNKNOWN_AGGREGATION_TYPE";
    /** Calculates the distribution of a specific field's values within a dataset, providing insights into the overall distribution and key statistics of those values. */
    AggregationType["VALUE"] = "VALUE";
    /** Calculates the count of the values from the specified field in the dataset that fall within the range of each bucket you define. */
    AggregationType["RANGE"] = "RANGE";
    /** Calculates a single numerical value from a dataset, summarizing the dataset into one key metric: `COUNT_DISTINCT`, `SUM`, `AVG`, `MIN`, or `MAX`. */
    AggregationType["SCALAR"] = "SCALAR";
    /** Calculates the count of time values from the specified field in the dataset that fall within each time interval you define (hour, day, week, etc.). */
    AggregationType["DATE_HISTOGRAM"] = "DATE_HISTOGRAM";
    /** Flattened list of aggregations, where each aggregation is nested within previous one. */
    AggregationType["NESTED"] = "NESTED";
})(AggregationType || (AggregationType = {}));
export var SearchDetailsMode;
(function (SearchDetailsMode) {
    /** At least one of the search terms must be present. */
    SearchDetailsMode["OR"] = "OR";
    /** All search terms must be present. */
    SearchDetailsMode["AND"] = "AND";
})(SearchDetailsMode || (SearchDetailsMode = {}));
export var WebhookIdentityType;
(function (WebhookIdentityType) {
    WebhookIdentityType["UNKNOWN"] = "UNKNOWN";
    WebhookIdentityType["ANONYMOUS_VISITOR"] = "ANONYMOUS_VISITOR";
    WebhookIdentityType["MEMBER"] = "MEMBER";
    WebhookIdentityType["WIX_USER"] = "WIX_USER";
    WebhookIdentityType["APP"] = "APP";
})(WebhookIdentityType || (WebhookIdentityType = {}));
//# sourceMappingURL=types.impl.js.map